<div class="form-row--multi-select nolimits" [formGroup]="formGroup">
  <div class="multi-select margin--top-m margin--bottom-m">
    <div class="multi-select__list">
      <div class="multi-select__items">
        @if (customerNumbers().length) {
          @for (customerNumber of customerNumbers(); track customerNumber) {
            <div
              class="multi-select__item multi-select__item--tall"
              [class.multi-select__item--disabled]="editingCustomerNumber() === customerNumber"
              [attr.aria-disabled]="editingCustomerNumber() === customerNumber">
              <div class="access-group-item flex">
                <div class="access-group-item__name">
                  Kundenr.: <span>{{ customerNumber }}</span>
                </div>
                <div class="flex gap-6">
                  <button
                    type="button"
                    mat-icon-button
                    matBadgeColor="primary"
                    matBadgeSize="large"
                    title="Rediger"
                    [disabled]="editingCustomerNumber() === customerNumber"
                    (click)="startEditCustomerNumber(customerNumber)">
                    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
                  </button>
                  <button
                    type="button"
                    mat-icon-button
                    class="delete"
                    title="Fjern"
                    matBadgeColor="primary"
                    matBadgeSize="large"
                    [disabled]="editingCustomerNumber() === customerNumber"
                    (click)="removeCustomerNumber(customerNumber)">
                    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
                  </button>
                </div>
              </div>
            </div>
          }
        } @else {
          <em class="margin--bottom-m block">Der er ingen kundenumre tilknyttet.</em>
        }
      </div>
      <div class="multi-select__input">
        <div class="flex filter-dropdown">
          <div class="customer-number-field margin--bottom-m">
            <adm-g4-customer-number [control]="customerNumberControl" (keydown.enter)="addCustomerNumber(); $event.preventDefault()" />
          </div>
          <button
            mat-flat-button
            color="primary"
            [title]="editingCustomerNumber() !== null ? 'Gem redigering' : 'Tilføj'"
            type="button"
            (click)="addCustomerNumber()"
            class="add-button margin--left-s"
            [disabled]="isAddCustomerNumberBlocked()">
            @if (editingCustomerNumber() !== null) {
              <mat-icon>check</mat-icon>
            } @else {
              <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
            }
          </button>
          @if (editingCustomerNumber() !== null) {
            <button mat-stroked-button type="button" class="margin--left-s" (click)="cancelEditCustomerNumber()">Annuller</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
